var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Steps',{staticClass:"p-t-10",attrs:{"current":_vm.current}},_vm._l((_vm.steps),function(step,i){return _c('Step',{key:i,attrs:{"title":step.title,"content":step.desc}})}),1),_c('div',{staticStyle:{"margin":"30px 15px"}},[_c(_vm.component,{ref:"stepComponent",tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }